/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountRewardInfo,
    AccountRewardInfoFromJSON,
    AccountRewardInfoFromJSONTyped,
    AccountRewardInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountRewardResponse
 */
export interface AccountRewardResponse {
    /**
     * 
     * @type {Array<AccountRewardInfo>}
     * @memberof AccountRewardResponse
     */
    list: Array<AccountRewardInfo>;
    /**
     * 
     * @type {number}
     * @memberof AccountRewardResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRewardResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRewardResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRewardResponse
     */
    totalSize?: number;
}

export function AccountRewardResponseFromJSON(json: any): AccountRewardResponse {
    return AccountRewardResponseFromJSONTyped(json, false);
}

export function AccountRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountRewardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AccountRewardInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function AccountRewardResponseToJSON(value?: AccountRewardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AccountRewardInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


